require('./bootstrap');
require('lazyload');
require('popper.js');

import * as lightbox from 'lightbox2';

Inputmask('99/99/9999').mask($('#birthdate'));
Inputmask({ mask: '(99) 99999-9999', removeMaskOnSubmit: true }).mask($('#phone'));
Inputmask({ mask: '(99) 99999-9999', removeMaskOnSubmit: true }).mask($('#relative_phone'));

let $state = $('#state')

$state.change(event => {
  reloadCities();
});

// Recarrega as cidades com base no estado selecionado
function reloadCities(selectedCity) {
  let $city = $('#city');

  $.ajax({
    method: 'GET',
    url: `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${$state.val()}/municipios`
  }).done(data => {
    $city.empty();

    for (let index = 0; index < data.length; index++) {
      const city = data[index];

      if (selectedCity == city.id) {
        $city.append(`<option value="${city.id}" selected>${city.nome}</option>`);
      }
      else {
        $city.append(`<option value="${city.id}">${city.nome}</option>`);
      }
    }
  });
}

// Seleciona Botucatu automaticamente
$state.val('35');
reloadCities(3507506);

lightbox.option({
  albumLabel: 'Imagem %1 de %2',
  disableScrolling: true
});

$('.tabs a').each((index, elem) => {
  let targetEl = $($(elem).data('target'));

  $(elem).click(() => {
    let parentEl = $(elem).parent('li');

    parentEl.siblings().each((_, s) => {
      $(s).removeClass('is-active')
      $($('a', $(s)).data('target')).addClass('is-hidden');
    });
    parentEl.addClass('is-active');

    targetEl.removeClass('is-hidden');
  });
});

// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  // On-page links
  if (location.pathname.replace(/^\\\//, '') == this.pathname.replace(/^\\\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 10
      }, 700, function() {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        };
      });
    }
  }
});

// $('#close-warning').click(() => {
//   $('#warning-modal').removeClass('is-active');
//   $('html').removeClass('is-clipped');
// });

if (document.getElementById('warning')) {
  // $('html').addClass('is-clipped');
  $(document).scrollTop($('#ajuda').offset().top);
}

let currentPair = 1;

setInterval(function() {
  $('#photo-' + currentPair).addClass('carousel-img-hidden');

  currentPair++;

  if (currentPair > 7)
    currentPair = 1;

  $('#photo-' + currentPair).removeClass('carousel-img-hidden');
}, 5000);
